export const HTTP_NOT_FOUND = 404;
